import React, { useState, useEffect } from 'react';

function SubmissionPage({handleSubmission}) {
  const [seconds, setSeconds] = useState(10);

  useEffect(() => {
    if (seconds === 0) handleSubmission();

    const timer = setInterval(() => {
      setSeconds(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);
  
  return (
      <div className='w-screen h-screen content-center justify-items-center bg-[#f9ece2] text-[#223641]' onClick={()=>handleSubmission()}>
        <img className='w-1/2 max-w-lg' src={process.env.PUBLIC_URL + '/logo.png'}/>
          <h1 className='text-5xl font-bold'>Thank you for your submission</h1>
          <h3 className='text-2xl'>Our teams will get back to you in 3 to 5 working days</h3>
          <img className='w-1/4 my-10' src={process.env.PUBLIC_URL + '/heart.png'}/>
          <h2 className='text-2xl'>We're so glad that you chose our clinic for your medical needs.</h2>
          <h3 className='mt-2'>Returning back to homepage in... {seconds}</h3>
      </div>
    );
}

export default SubmissionPage;